export class ServiceRestError extends Error {
  response: Response;
  url: string;
  status: number | null;
  json: any | null;
  text: string | null;
  error_key: string;

  constructor(response: Response, json: any | null, text: string | null) {
    super(`${response.status} - ${response.url}: ${text}`);
    this.name = "ServiceError";
    this.url = response.url;
    this.json = json;
    this.text = text;
    this.status = response.status;
    this.response = response;
    this.error_key = "undefined"; // TODO: key from msg
  }
}

export async function raiseFromStatus(response: Response): Promise<Response> {
  if (response.status && response.status < 400) {
    return response;
  }
  const text = await response.text();
  let json: string | null = null;
  try {
    json = JSON.parse(text);
  } catch (err) {}
  throw new ServiceRestError(response, json, text);
}
